<template>
  <div id="bread-nav">
    <div class="bread-nav-container w">
      <span class="left-nav">
        <span class="goback" @click="goback"> < 返回上级 </span>
        <a href="/">首页</a>
        &gt;
        <router-link v-if="goods.category_id" :to="'/goods?category=' + goods.category_id">{{ goods.category_name }}</router-link>
        <router-link v-else :to="'/goods?keyword=' + goods.category_name">{{ goods.category_name }}</router-link>
        &gt;
        <a href="javascript:;" v-html="goods.goods_name || goods.name">{{ goods.goods_name || goods.name }}</a>
      </span>
      <!-- <span>商品编码：{{ goods.sn }}</span> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bread-nav',
    props: ['goods'],
    methods: {
      goback(){
        // alert(1)
        console.log('this.$route1', this.$route);
        localStorage.setItem('fromRoute', this.$route.name);
        this.$router.go(-1)
        
      }
    },
  }
</script>

<style lang="scss" scoped>
  .bread-nav-container {
    display: flex;
    justify-content: space-between;
    padding: 30px 0;
    color: #333333;
    font-weight: 400;
  }
  .left-nav {
    a:last-child {
      font-family: serif;
    }
  }

  .goback {
    margin-right: 10px;
    &:hover {
      color: crimson;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/-bread-nav.vue